import { render, staticRenderFns } from "./edittrailer.vue?vue&type=template&id=c38e641c&scoped=true"
import script from "./edittrailer.js?vue&type=script&lang=js&external"
export * from "./edittrailer.js?vue&type=script&lang=js&external"
import style0 from "./edittrailer.vue?vue&type=style&index=0&id=c38e641c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38e641c",
  null
  
)

export default component.exports